<template>
  <div class="bn-banner">
    <div class="bn-left">
      <div class="bn-eyebrow">
        <span class="bn-badge">BLACK NOVEMBER</span>
        <span class="bn-dates">DE 03 A 29 DE NOVEMBRO</span>
      </div>
      <div class="bn-text">
        <p class="bn-headline">Telefonia ilimitada e IA de vendas com <span class="bn-highlight">até 75% off</span></p>
        <p class="bn-support">No pacote Ilimitado + IA4COM, para novas contratações: 69% off nos 2 primeiros meses do mensal e 75% off nos 4 primeiros meses do anual.</p>
      </div>
      <div class="bn-actions">
        <button type="button" class="bn-contact" @click="$emit('contact')">Falar com o time</button>
        <a
          v-if="rulesUrl"
          :href="rulesUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="bn-rules">
          Ver regras da promoção
          <img :src="arrowIcon" alt="" width="20" height="20">
        </a>
      </div>
    </div>

    <div class="bn-right">
      <div class="bn-offers">
        <div class="bn-offer">
          <p class="bn-offer-label">MENSAL</p>
          <p class="bn-offer-percent">69% off</p>
          <p class="bn-offer-detail">R$ 104,95 por usuário, nos 2 primeiros meses</p>
        </div>
        <!-- Anual é venda manual pelo CS: o billing não tem preço anual -->
        <div class="bn-offer bn-offer--annual">
          <p class="bn-offer-label">ANUAL</p>
          <p class="bn-offer-percent">75% off</p>
          <p class="bn-offer-detail">R$ 83,96 por usuário, nos 4 primeiros meses</p>
        </div>
      </div>
      <div class="bn-countdown">
        <p class="bn-countdown-label">TERMINA EM:</p>
        <div class="bn-countdown-units">
          <div v-for="unit in countdownUnits" :key="unit.label" class="bn-unit">
            <span class="bn-unit-value">{{ unit.value }}</span>
            <span class="bn-unit-label">{{ unit.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import arrowIcon from '@/assets/images/plans/arrow-up-right-white.svg'

export default {
  name: 'BlackNovemberBanner',
  props: {
    // { days, hours, minutes, seconds }, já com dois dígitos
    countdown: {
      type: Object,
      required: true
    },
    // Vazio esconde o link (ainda sem endereço; vem de variável de ambiente)
    rulesUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return { arrowIcon }
  },
  computed: {
    countdownUnits () {
      return [
        { label: 'DIAS', value: this.countdown.days },
        { label: 'HORAS', value: this.countdown.hours },
        { label: 'MIN', value: this.countdown.minutes },
        { label: 'SEG', value: this.countdown.seconds }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
$yellow: #ffd23f;
$on-yellow: #120d00;
$soft-text: #cbd5e1;
$card-bg: #161a24;
$card-border: #2a3040;

.bn-banner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  padding: 20px 24px;
  border-radius: 12px;
  overflow: hidden;
  background-image: linear-gradient(156.36deg, #171206 0%, #0b0f18 62%);
  font-family: 'Inter', ui-sans-serif, system-ui, sans-serif;

  p { margin: 0; }
}

.bn-left {
  flex: 1 1 420px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.bn-eyebrow { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.bn-badge {
  padding: 4px 8px;
  border-radius: 6px;
  background: $yellow;
  color: $on-yellow;
  font-size: 12px; line-height: 16px; font-weight: 700;
}
.bn-dates { color: $yellow; font-size: 12px; line-height: 16px; font-weight: 600; }
.bn-text { display: flex; flex-direction: column; gap: 4px; }
// Título e percentuais na Sora, como no Figma (pedido do usuário, 26/10); o resto é Inter.
$display-font: 'Sora', 'Inter', ui-sans-serif, system-ui, sans-serif;

.bn-headline { color: #fff; font-family: $display-font; font-size: 24px; line-height: 32px; font-weight: 700; letter-spacing: -0.48px; }
.bn-highlight { color: $yellow; }
// Sem largura máxima: em tela larga o texto ocupa o espaço até o bloco da direita, em
// vez de deixar um vão no meio do banner (decisão do usuário, 26/10).
.bn-support { color: $soft-text; font-size: 16px; line-height: 24px; }

.bn-actions { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; }
.bn-contact {
  padding: 10px 14px;
  border: 1px solid $yellow;
  border-radius: 8px;
  background: $yellow;
  color: $on-yellow;
  font-family: inherit; font-size: 14px; line-height: 20px; font-weight: 600;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  cursor: pointer;
  &:hover { filter: brightness(0.95); }
}
.bn-rules {
  display: inline-flex; align-items: center; gap: 6px;
  color: #fff;
  font-size: 14px; line-height: 20px; font-weight: 600;
  text-decoration: underline;
  &:hover { color: #fff; opacity: 0.85; }
  img { display: block; flex-shrink: 0; }
}

.bn-right { flex: 0 0 auto; display: flex; flex-direction: column; gap: 12px; }
.bn-offers { display: flex; gap: 12px; width: 300px; }
.bn-offer {
  flex: 1 1 0;
  min-width: 0;
  display: flex; flex-direction: column; gap: 2px;
  padding: 12px;
  border: 1px solid $card-border;
  border-radius: 14px;
  background: $card-bg;
}
.bn-offer-label { color: $soft-text; font-size: 12px; line-height: 16px; font-weight: 600; }
.bn-offer-percent { color: #fff; font-family: $display-font; font-size: 28px; line-height: 34px; font-weight: 800; white-space: nowrap; }
.bn-offer-detail { color: $soft-text; font-size: 12px; line-height: 16px; }
.bn-offer--annual {
  border-color: $yellow;
  .bn-offer-label, .bn-offer-percent { color: $yellow; }
}

.bn-countdown { display: flex; flex-direction: column; gap: 8px; }
.bn-countdown-label { color: $soft-text; font-size: 12px; line-height: 16px; font-weight: 600; }
.bn-countdown-units { display: flex; gap: 6px; }
.bn-unit {
  min-width: 58px;
  display: flex; flex-direction: column; align-items: center;
  padding: 6px;
  border: 1px solid $card-border;
  border-radius: 10px;
  background: $card-bg;
}
.bn-unit-value { color: #fff; font-size: 20px; line-height: 24px; font-weight: 800; }
.bn-unit-label { color: $soft-text; font-size: 10.5px; font-weight: 700; letter-spacing: 0.6px; }

@media (max-width: 600px) {
  .bn-offers { width: 100%; }
}
</style>



// WEBPACK FOOTER //
// src/components/Subscription/BlackNovemberBanner.vue